
class PublicKey {
  constructor(algorithm) {
    this.algorithm = algorithm;
  }

  
}

export default PublicKey;
